import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';

export const state = initialState();

function initialState() {
  return {
    programModel: null,
    selectedProgram: null,
    allPrograms: null,
    allProgramsTrueSource: [],
    hasUnsavedProgramChanges: false,
  };
}

export const getters = {
  hasUnsavedProgramChanges(state) {
    return state.hasUnsavedProgramChanges;
  },
};

export const mutations = {
  setProgramModel(state, value) {
    state.programModel = value;
  },
  setHasUnsavedProgramChanges(state, value) {
    state.hasUnsavedProgramChanges = value;
  },
  setSelectedProgram(state, value) {
    state.selectedProgram = value;
  },
  setAllPrograms(state, value) {
    state.allPrograms = value;
  },
  setAllProgramsTrueSource(state, value) {
    state.allProgramsTrueSource = value;
  },
  setUpdateProgramItem(state, value) {
    const programsClone = cloneDeep(state.allPrograms);
    const i = programsClone.findIndex((program) => program._id === value._id);
    programsClone[i] = value;
    state.allPrograms = programsClone;

    const programsTrueSourceClone = cloneDeep(state.allProgramsTrueSource);
    const j = programsTrueSourceClone.findIndex(
      (program) => program._id === value._id
    );
    programsTrueSourceClone[j] = value;
    state.allProgramsTrueSource = programsTrueSourceClone;
  },
  setAddNewProgram(state, value) {
    const programsClone = cloneDeep(state.allPrograms);
    programsClone.unshift(value);
    state.allPrograms = programsClone;

    const programsTrueSourceClone = cloneDeep(state.allProgramsTrueSource);
    programsTrueSourceClone.unshift(value);
    state.allProgramsTrueSource = programsTrueSourceClone;
  },
  setDeleteProgramItem(state, value) {
    const programsClone = cloneDeep(state.allPrograms);
    const i = programsClone.findIndex((program) => program._id === value._id);
    programsClone.splice(i, 1);
    state.allPrograms = programsClone;

    const programsTrueSourceClone = cloneDeep(state.allProgramsTrueSource);
    const j = programsTrueSourceClone.findIndex(
      (program) => program._id === value._id
    );
    programsTrueSourceClone.splice(j, 1);
    state.allProgramsTrueSource = programsClone;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {
  createNewProgram(ctx, programObj) {
    const url = api.URL_CREATE_NEW_PROGRAM.replace(':orgID', programObj.org_id)
      .replace(':trainerID', programObj.trainer_id)
      .replace(':userID', programObj.user_id);

    // Minimum data check for obj
    if (
      programObj.org_id !== undefined &&
      programObj.trainer_id !== undefined &&
      programObj.user_id !== undefined &&
      programObj.creation_date !== undefined
    ) {
      const payload = { program: programObj };
      return axios
        .put(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setAddNewProgram', res.data.program);
            return res;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ creation_date, org_id, trainer_id ]',
        programObj
      );
    }
  },

  duplicateProgram(ctx, programObj) {
    const url = api.URL_DUPLICATE_PROGRAM.replace(':programID', programObj.id);

    // Minimum data check for obj
    if (programObj.id !== undefined && programObj.label !== undefined) {
      const payload = { label: programObj.label };
      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setAddNewProgram', res.data.program);
            return res;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ id, label ]',
        programObj
      );
    }
  },

  getProgram(ctx, programObj) {
    const url = api.URL_GET_PROGRAM.replace(':programID', programObj.programId)
      .replace(':orgID', programObj.orgId)
      .replace(':trainerID', programObj.trainerId)
      .replace(':userID', programObj.userId);

    // Minimum data check for obj
    if (
      programObj.programId !== undefined &&
      programObj.orgId !== undefined &&
      programObj.trainerId !== undefined &&
      programObj.userId !== undefined
    ) {
      return axios
        .get(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setSelectedProgram', res.data.program);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ programId, orgId, trainerId, userId ]',
        programObj
      );
    }
  },

  updateProgram(ctx, programObj) {
    const url = api.URL_UPDATE_PROGRAM.replace(
      ':programID',
      programObj.programId
    )
      .replace(':orgID', programObj.orgId)
      .replace(':trainerID', programObj.trainerId)
      .replace(':userID', programObj.userId);

    // Minimum data check for obj
    if (
      programObj.programId !== undefined &&
      programObj.orgId !== undefined &&
      programObj.trainerId !== undefined &&
      programObj.userId !== undefined
    ) {
      return axios
        .post(url, programObj)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setSelectedProgram', res.data.program);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ programId, orgId, trainerId, userId ]',
        programObj
      );
    }
  },

  deleteProgram(ctx, programObj) {
    const url = api.URL_DELETE_PROGRAM.replace(
      ':programID',
      programObj.programId
    )
      .replace(':orgID', programObj.orgId)
      .replace(':trainerID', programObj.trainerId)
      .replace(':userID', programObj.userId);

    // Minimum data check for obj
    if (
      programObj.programId !== undefined &&
      programObj.orgId !== undefined &&
      programObj.trainerId !== undefined &&
      programObj.userId !== undefined
    ) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setDeleteProgramItem', programObj.program);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ programId, orgId, trainerId, userId ]',
        programObj
      );
    }
  },

  getAllPrograms(ctx, { orgId, trainerId, userId = 0 }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_ALL_PROGRAM.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllPrograms', res.data.programs);
          ctx.commit('setAllProgramsTrueSource', res.data.programs);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId, userId) : (${orgId}, ${trainerId}, ${userId})`
      );
    }
  },

  getProgramModel(ctx, { orgId, trainerId, userId = 0 }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_PROGRAM_SHAPE.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setProgramModel', res.data.program);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },
};
